export const findTranslation = (value, options = []) => {
  const result = options.find(option => option.value === value);
  return result ? result.label : null
}